<template>
  <div>
    <!-- {{idData}} -->
    <!-- <b-button @click="generatePdf" variant="primary"> Download PDF </b-button> -->
    <Loader v-if="isLoadingData" fullPage useOverlay loader="spinner"></Loader>
  </div>
</template>

<script>
import Loader from "@/components/Loader/Loader";
import pdfMake from "pdfmake/build/pdfmake";
import { fnPOST } from "../../../../api/api-methods";
import { APIPATH_SALESFORCE } from "../../../../api/api-paths";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { EventBus } from "./eventBus";
import { mapActions, mapGetters } from "vuex";

let APIDomain = new URL(window.location.href);
if (APIDomain.hostname != "localhost") {
  pdfMake.vfs = pdfFonts.pdfMake.vfs;
}

export default {
  components: {
    Loader,
  },
  data() {
    return {
      isLoadingData: false,
      monthNames: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      idData: null,
      customerGroup: null,
      orderDate: null,
      sample: null,
      dataArray: [],
      dataPO: [],
      dataPORecipt: [],
      dataPOOrder: [],
      dataUkur: [],
      dataPOProduct: [],
      svgPO: null,
      userid: null,
      username: null,
      leader_name:null,
    };
  },

  computed: {
    ...mapGetters("session", ["userData"]),
  },

  methods: {
    ...mapActions("session", ["showNotification"]),
    FormatDate(value) {
      console.log('value');
      console.log(value);
      if (value == null || value == undefined || value == "" || value == "NaN" || value == '-') {
        return "-";
      } else {
        let date = new Date(value);
        let day = date.getDate();
        if (String(day).length == 1) {
          day = "0" + String(day);
        }
        let year = date.getFullYear();
        let bulan = this.monthNames[date.getMonth()];
        date = day + " " + bulan + " " + year;
        if (date == "NaN undefined NaN" ||date == "NaN NaN NaN") {
          return "-";
        }
        return date;
      }
    },
    async generatePdf() {
      try {
        this.isLoadingData = true;
        const now = new Date();

        const poNumber =
          `PO/BBI/${now.getFullYear()}/` +
          `${String(now.getMonth() + 1).padStart(2, "0")}/` +
          `${Math.random().toString(36).substring(2, 10).toUpperCase()}`;
        const content = [];

        let data = this.dataPO[0];
        let data_customer = ''
        let data_sample =  ''
        let data_order = []
        let no = 1;
        this.dataPO.forEach((val) => {
          val.no = no;
          no++;
          if (!(data_customer.includes(val.customer_name+', '))) {
            data_customer += val.customer_name+', '
          }
          if (!(data_sample.includes(val.sample_no+', '))) {
            data_sample += val.sample_no+', '
          }
          // console.log(val.order_date)
          // if (val.order_date) {
          //   let dateOrder = this.FormatDate(val.order_date)
          //   if (!(data_order.includes((dateOrder)))) {
          //     data_order += dateOrder+', '
          //   }
          // }
          
        
        
        });

        const total = this.dataPO.reduce(
          (sum, row) => sum + row.qty * row.price,
          0
        );


        const sumqty = this.dataPO.reduce((sum, row) => sum + row.qty, 0);

        const tableRows = [];

        this.dataPO.forEach((row) => {

          let ukuranColumns = [];

          if (row.data_ukur) {

            let dataUkur = row.data_ukur;

            if (typeof dataUkur === 'string') {

              dataUkur = dataUkur.replace(/'/g, '"');

              dataUkur = JSON.parse(dataUkur);
            }

            // ===== GROUP DATA =====
            const grouped = Object.values(
              dataUkur.reduce((acc, item) => {

                if (!acc[item.article]) {
                  acc[item.article] = {
                    article: item.article,
                    sizes: {}
                  };
                }

                if (!acc[item.article].sizes[item.size]) {
                  acc[item.article].sizes[item.size] = 0;
                }

                acc[item.article].sizes[item.size] += item.qty;

                return acc;

              }, {})
            );

            ukuranColumns = grouped.map(article => {

              const sizeText = Object.entries(article.sizes)
                .map(([size, qty]) => `${size}: ${qty}`)
                .join(', ');

              return {
                article: article.article,
                sizeText: sizeText
              };

            });

          }

          // ===== MAIN ROW =====
           // ===== MAIN ROW =====
            tableRows.push([
              row.no,
              row.po,
              row.product_info,
              row.sample_no,
              row.brand,
              row.fabric,
              row.embro_info,
              row.packaging_group,
              row.packaging_type,
              this.FormatDate(row.order_date),
              this.FormatDate(row.delivery_date),
              { text: row.part_no, alignment: "right" },
              { text: row.qty, alignment: "right" },
              { text: (row.price * 1).toLocaleString(), alignment: "right" },
              { text: (row.qty * row.price).toLocaleString(), alignment: "right" },
            ]);

          // ===== UKURAN ROW =====
          // ===== UKURAN TABLE STYLE =====
          // ===== UKURAN ROW =====
          if (ukuranColumns.length > 0) {

            tableRows.push([
              {
                colSpan: 15,
                margin: [10, 0, 0, 5], // margin left 10

                stack: [

                  {
                    table: {

                      widths: Array(ukuranColumns.length).fill('*'),

                      body: [

                        // ===== ARTICLE ROW =====
                        ukuranColumns.map(col => ({
                          text: `${col.article} : ` + col.sizeText,
                          bold: true,
                          fontSize: 8,
                          alignment: 'left'
                        })),


                      ]

                    },

                    layout: {
                      hLineWidth: () => 0,
                      vLineWidth: () => 0,
                      paddingLeft: () => 0,
                      paddingRight: () => 5,
                      paddingTop: () => 0,
                      paddingBottom: () => 0,
                    }

                  }

                ]
              },

              "", "", "", "", "", "", "", "", "", "", "", "", "", "",

            ]);

          }

        });

        // ===== FOOTER =====
        tableRows.push([
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "Total",

          { text: sumqty.toLocaleString(), alignment: "right" },

          "",
          "",

          { text: total.toLocaleString(), alignment: "right" },

        ]);

        content.push(
          {
            table: {
              widths: ["100%"],
              body: [
                [
                  {
                    text: "PT BINABUSANA INTERNUSA",
                    alignment: "center",
                    bold: true,
                    fontSize: 16,
                    margin: [0, 5, 0, 5],
                  },
                ],
                [
                  {
                    text: "DETAIL PURCHASE ORDER",
                    alignment: "center",
                    bold: true,
                    fontSize: 14,
                    margin: [0, 5, 0, 5],
                  },
                ],
              ],
            },
            layout: {
              hLineWidth: () => 1,
              vLineWidth: () => 1,
              hLineColor: () => "#000000",
              vLineColor: () => "#000000",
            },
            margin: [0, 0, 0, 10],
          },

          {
            columns: [
              {
                width: "85%",
                stack: [
                  {
                    table: {
                      widths: ["20%", "80%"],
                      body: [
                        [
                          { text: "Group Customer", bold: true },
                          data.customer_group,
                        ],
                        [
                          { text: "Nama Customer", fontSize: 10, bold: true },
                          data_customer,
                        ],
                        // [
                        //   { text: "JenisCustomer", bold: true },
                        //   data.type_customer,
                        // ],
                        // [
                        //   { text: "Tanggal Order", bold: true },
                        //   data_order,
                        // ],
                        [{ text: "Total Order (PCS)", bold: true }, sumqty],
                        // [{ text: "No. Sample", bold: true }, data_sample],
                        // [{ text: "Merek", bold: true }, data.brand],
                        // [{ text: "Material/Fabric", bold: true }, data.fabric],
                      ],
                    },
                    layout: "noBorders",
                    margin: [0, 0, 0, 10],
                  },
                ],
              },
              {
                width: "15%",
                stack: [
                  {
                    table: {
                      widths: ["100%"],
                      body: [
                        [
                          {
                            text: "Swatches",
                            bold: true,
                            alignment: "center",
                            margin: [0, 30, 0, 30],
                            border: [true, true, true, true],
                          },
                        ],
                      ],
                    },
                    margin: [0, 0, 0, 30],
                    layout: {
                      hLineWidth: () => 1,
                      vLineWidth: () => 1,
                      hLineColor: () => "#000000",
                      vLineColor: () => "#000000",
                    },
                  },
                ],
              },
            ],
          },
          // ===== TABLE =====
          {
            table: {

              headerRows: 1,
              widths: [
                  15, // NO
                  50, // No PO/SPK/SKO
                  '*', // Produk
                  30, // Sample
                  30, // Merek
                  50, // Material/Fabric
                  60, // Bordir
                  40, // Pengelompokan Kemasan
                  42, // Pengiriman
                  40, // Tanggal Order
                  40, // Tanggal Terima
                  15, // Part
                  20, // Qty
                  50, // Harga PCS (IDR)
                  60, // Total Harga (IDR)
              ],
              body: [

                [
                  { text: "NO", bold: true },
                  { text: "No PO/SPK/SKO", bold: true },
                  { text: "Produk", bold: true },
                  { text: "Sample", bold: true },
                  { text: "Merek", bold: true },
                  { text: "Material/Fabric", bold: true },
                  { text: "Bordir", bold: true },
                  { text: "Pengelompokan kemasan", bold: true },
                  { text: "Pengiriman", bold: true },
                  { text: "Tanggal Order", bold: true },
                  { text: "Tanggal Terima", bold: true },
                  { text: "Part", bold: true },
                  { text: "Qty", bold: true },
                  { text: "Harga PCS (IDR)", bold: true },
                  { text: "Total Harga (IDR)", bold: true },
                ],

                ...tableRows,

              ],

            },

            layout: {
              hLineWidth: function(i, node) {

                if (i === 0) return 1;
                if (i === 1) return 1;
                if (i === node.table.body.length) return 1;

                const currentRow = node.table.body[i];

                // remove line between main row and ukuran row
                if (
                  currentRow &&
                  currentRow[0] &&
                  currentRow[0].colSpan === 15
                ) {
                  return 0;
                }

                return 1;
              },

              vLineWidth: function() {
                return 0;
              },

              hLineColor: function() {
                return "#CCCCCC";
              }
            },

            fontSize: 8,
          },
          {
            text: "Lampiran Pendukung",
            bold: true,
            margin: [0, 10, 0, 5],
          },
          {
            table: {
              widths: ["20%", "20%", "20%"],
              body: [
                [
                  {
                    columns: [
                      {
                        svg: this.svgPO,
                        width: 10,
                      },
                      { text: "COGM", margin: [5, 0] },
                    ],
                  },
                  {
                    columns: [
                      {
                        svg: this.svgPO,
                        width: 10,
                      },
                      { text: "Data Ukur", margin: [5, 0] },
                    ],
                  },
                  { text: "Lainnya _______", alignment: "center" },
                ],
              ],
            },
            layout: "noBorders",
            margin: [0, 0, 0, 10],
          },
        
          {
              // pageBreak: 'before',
              stack: [
                // ===== Row 1 =====
                {
                  columns: [
                    {
                      text: "Dibuat Oleh,",
                      alignment: "center",
                    },
                    {
                      text: "",
                    },
                    {text: "Diperiksa Oleh,",
                      alignment: "left"},
                    
                  ]
                },

                // ===== Row 2 =====
                {
                  columns: [
                    {
                      text: `\n\n\n\n(${this.username})\nSales Executive`,
                      alignment: "center",
                    },
                    {
                      text: `\n\n\n\n(${this.leader_name || ' Dwi Paryanti '})\nSection Head`,
                      alignment: "center",
                    },
                    {
                      text: `\n\n\n\n( Widya Ranitya )\nDept Head`,
                      alignment: "center",
                    }
                  ]
                },

                // ===== Row 3 =====
                {
                  text: "\n\nDisetujui Oleh,",
                  alignment: "center",
                },

                // ===== Row 4 =====
                {
                  columns: [
                    {
                      text: `\n\n\n\n(${data.divHead || ' Lidya Ridiani '})\nDivision Head Sales`,
                      alignment: "center",
                    },
                    {
                      text: `\n\n\n\n(${data.coo || ' Jason Edward Wuysang '})\nCOO`,
                      alignment: "center",
                    }
                  ]
                }
              ]
          },
        );
        content.push({ text: "", pageBreak: "after" });

        let data_id = [];
        this.dataPO.forEach((val) => {
          if (!data_id.includes(val.customer_id)) {
            data_id.push(val.customer_id);
            content.push({
              columns: [
                {
                  width: "50%",
                  stack: [
                    {
                      text: "IDENTITAS PENERIMA",
                      bold: true,
                      margin: [10, 10, 10, 10],
                    },
                    {
                      table: {
                        widths: ["40%", "60%"],
                        body: [
                          [{ text: "Nama", bold: true }, val.name_recipt],
                          [
                            { text: "No. Telephone/E-mail", bold: true },
                            val.telp_recipt,
                          ],
                          [
                            { text: "Alamat Pengiriman", bold: true },
                            val.address_recipt,
                          ],
                        ],
                      },
                      layout: "noBorders",
                    },
                  ],
                },
                {
                  width: "50%",
                  stack: [
                    {
                      text: "IDENTITAS PENAGIHAN PEMBAYARAN",
                      bold: true,
                      margin: [10, 10, 10, 10],
                    },
                    {
                      table: {
                        widths: ["40%", "60%"],
                        body: [
                          [{ text: "Nama", bold: true }, val.name_collect],
                          [
                            { text: "No. Telephone/E-mail", bold: true },
                            val.telp_collect,
                          ],
                          [
                            { text: "Alamat Penagihan", bold: true },
                            val.address_collect,
                          ],
                        ],
                      },
                      layout: "noBorders",
                    },
                  ],
                },
              ],
            });
          }
        });
        const docDefinition = {
          footer: function(currentPage, pageCount) {
              return {
                  margin: [40, 0, 40, 20],
                  columns: [
                      {
                          text: `Page ${currentPage} of ${pageCount}`,
                          alignment: 'left',
                          fontSize: 8
                      },
                      {
                          text: poNumber,
                          alignment: 'right',
                          fontSize: 8,
                          bold: true
                      }
                  ]
              };
          },
          styles: {
            tableHeader: {
              fontSize: 9,
              bold: true,
              alignment: "center",
            },
            tableBody: {
              fontSize: 8,
            },
          },
          defaultStyle: {
            fontSize: 10,
          },
          content: content,
          pageSize: "A4",
          pageMargins: [10, 10, 10, 10], // Adjust margins as needed
          pageOrientation: "landscape",
        };

        console.log(docDefinition);
        console.log(content);
        pdfMake.createPdf(docDefinition).getBlob((blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.target = "_blank"; // Opens in a new tab
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(url); // Clean up the URL
        });

        this.isLoadingData = false;
      } catch (error) {
        this.isLoadingData = false;
        this.showNotification({ type: "error", message: error });
      }
    },

    loadDataPO() {
      this.isLoadingData = true;
      fnPOST(APIPATH_SALESFORCE.getFormPOCombine, {
        customer_id: this.idData,
        customer_group: this.customerGroup,
        order_date: this.orderDate,
        sample: this.sample,
      })
        .then((rsp) => {
          this.isLoadingData = false;
          this.dataPO = rsp.data.payload;
          this.loadPdfArray();
        })
        .catch((err) => {
          this.isLoadingData = false;
          this.showNotification({ type: "error", message: err });
        });
    },

    loadPdfArray() {
      this.svgPO =
        '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>';

      this.generatePdf();
    },

    async setData() {
      this.loadSalesNik()

    },

    loadSalesNik() {
      fnPOST(APIPATH_SALESFORCE.getSalesPerson, {
        sales: this.userid,
      }).then(rsp=> {
        let data = rsp.data.payload[0]
        this.leader_name = '____________________'
        if (data) {
          if (data.leader_name) {
            this.leader_name = data.leader_name
          }
        }
        this.loadDataPO();
      })
    },
    FormatDate(value) {
      if (value == null || value == undefined || value == "" || value == '-') {
        return " ";
      } else {
        let date = new Date(value);
        let day = date.getDate();
        if (String(day).length == 1) {
          day = "0" + String(day);
        }
        let year = date.getFullYear();
        let bulan = this.monthNames[date.getMonth()];
        date = day + " " + bulan + " " + year;
        if (date == "NaN undefined NaN" ||date == "NaN NaN NaN") {
          return "-";
        }
        return date;
      }
    },
  },
  created() {
    this.userid = this.userData.username;
    this.username = this.userData.fullname;
    EventBus.$on("open-ketpo-combine", (data) => {
      console.log(data);
      this.idData = data.idData;
      this.customerGroup = data.groupCustomer;
      this.orderDate = data.orderDate;
      this.sample = data.sample;
      this.setData();
    });
  },

  beforeDestroy() {
    EventBus.$off("open-ketpo-combine");
  },
};
</script>

<style>
/* Optional styles for your button */
</style>
